import { PanelDesignTokens } from '@primeuix/themes/types/panel';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/panel/index.ts
const pnl = tDeep(componentCommon.panel);

export const PanelTelekomDT: PanelDesignTokens = {
  root: {
    borderColor: pnl.border.color,
  },
  header: {
    padding: pnl.header.padding,
  },
  content: {
    padding: `${pnl.content.padding.top} ${pnl.content.padding.right} ${pnl.content.padding.bottom} ${pnl.content.padding.left}`,
  },
};
